import { createSlice } from '@reduxjs/toolkit';
import {
  fetchUsers,
  fetchRecruiters,
  fetchOutreachUsers,
  fetchExternalUsers,
} from './actions';

const initialState = {
  isLoading: true,
  data: [],
  recruiters: {
    isLoading: true,
    data: [],
  },
  outreachUsers: {
    isLoading: true,
    data: [],
  },
  externalUsers: {
    isLoading: true,
    data: [],
  },
};

const { reducer } = createSlice({
  name: 'users',
  initialState,

  reducers: {},

  extraReducers: {
    [fetchUsers.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchUsers.fulfilled]: (state, { payload }) => {
      state.data = payload?.data || [];
      state.isLoading = false;
    },

    [fetchRecruiters.pending]: (state) => {
      state.recruiters.isLoading = true;
    },
    [fetchRecruiters.fulfilled]: (state, { payload }) => {
      state.recruiters.data = payload?.data || [];
      state.recruiters.isLoading = false;
    },

    [fetchOutreachUsers.pending]: (state) => {
      state.outreachUsers.isLoading = true;
    },
    [fetchOutreachUsers.fulfilled]: (state, { payload }) => {
      state.outreachUsers.data = payload?.data || [];
      state.outreachUsers.isLoading = false;
    },
    [fetchExternalUsers.pending]: (state) => {
      state.externalUsers.isLoading = true;
    },
    [fetchExternalUsers.fulfilled]: (state, { payload }) => {
      state.externalUsers.data = payload?.data || [];
      state.externalUsers.isLoading = false;
    },
  },
});

export default reducer;
